import { Button, Stack } from "@mui/material";
import type { FC, ReactNode } from "react";
import CancelButton from "../../components/cancelButton/CancelButton";

interface Props {
  readonly onBackToOrder?: () => void;
  readonly middleContent?: ReactNode;
  readonly onEdit: () => void;
}

const ParticipantListViewActionBar: FC<Props> = ({ onBackToOrder, middleContent, onEdit }) => (
  <Stack
    direction="row"
    spacing={2}
    sx={{
      alignItems: "center",
    }}
  >
    {onBackToOrder ? <CancelButton onClick={onBackToOrder}>Wróć do zamówienia</CancelButton> : null}
    {middleContent}
    <Button variant="outlined" color="primary" onClick={onEdit}>
      Edytuj
    </Button>
  </Stack>
);

export default ParticipantListViewActionBar;
